import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DataOrder } from '../models/DataOrder';
import { CONSTANTES } from "../shared/global";

@Injectable({
    providedIn: 'root'
})
export class OrderService {

    public url: string;

    articulosGuardados = localStorage.getItem("articulos");
    private countArticles = new BehaviorSubject(this.articulosGuardados);
    currentArticles = this.countArticles.asObservable();
    private articulos = new BehaviorSubject<any>(this.articulosGuardados);

    private defaultSource = new BehaviorSubject(null);
    valueTime = this.defaultSource.asObservable();

    private statusSource = new BehaviorSubject(null);
    status = this.statusSource.asObservable();


    constructor(private http: HttpClient) {
        this.url = CONSTANTES.api_url + "/orders";
    }

    changeTime(time: string) {
        this.defaultSource.next(time)
    }

    changeStatus(status: string) {
        this.statusSource.next(status)
    }

    sendUpdate(message: string) { //the component that wants to update something, calls this fn
        this.articulos.next({ message }); //next() will feed the value in Subject
    }

    getUpdate(): Observable<any> { //the receiver component calls this function 
        return this.articulos.asObservable(); //it returns as an observable to which the receiver funtion will subscribe
    }

    /**Guarda las familias y subfamilias*/
    postBank(OrderObject: Object) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.post<DataOrder>(this.url + "/bank", JSON.stringify(OrderObject), { headers: iheaders });
    }

    getOrdersToConfirm(dataOrder: DataOrder) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<DataOrder>(this.url + "/ordersToConfirm", JSON.stringify(dataOrder), { headers: iheaders });
    }

    saveOrder(dataOrder: DataOrder) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<DataOrder>(this.url + "/save", JSON.stringify(dataOrder), { headers: iheaders });
    }

    modifyOrder(dataOrder: DataOrder) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<DataOrder>(this.url + "/modify", JSON.stringify(dataOrder), { headers: iheaders });
    }

    getOrderByUser(dataOrder: DataOrder) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<DataOrder>(this.url + "/userOrders", JSON.stringify(dataOrder), { headers: iheaders });
    }

    getReceiptOrders(dataOrder: DataOrder) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<DataOrder>(this.url + "/receipt", JSON.stringify(dataOrder), { headers: iheaders });
    }

    cancelOrders(dataOrder: DataOrder) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<DataOrder>(this.url + "/cancel", JSON.stringify(dataOrder), { headers: iheaders });
    }

    separateOrders(dataOrder: DataOrder) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<DataOrder>(this.url + "/separate", JSON.stringify(dataOrder), { headers: iheaders });
    }

    unifyOrders(dataOrder: DataOrder) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<DataOrder>(this.url + "/unify", JSON.stringify(dataOrder), { headers: iheaders });
    }

    getPreparationOrders() {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.get<DataOrder>(this.url + "/infopreparation", { headers: iheaders });
    }

    getShipmentOrders() {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.get<DataOrder>(this.url + "/infoshipment", { headers: iheaders });
    }

    getShipmentOrdersFinished() {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.get<DataOrder>(this.url + "/infoShipmentFinished", { headers: iheaders });
    }

    setShipmentOrders(dataOrder: DataOrder) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<DataOrder>(this.url + "/shipment", JSON.stringify(dataOrder), { headers: iheaders });
    }

    setPreparationOrders(dataOrder: DataOrder) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<DataOrder>(this.url + "/preparation", JSON.stringify(dataOrder), { headers: iheaders });
    }

    getFinishedOrders(orderNumberBank: string) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.get<DataOrder>(this.url + "/finishedOrders/" + orderNumberBank, { headers: iheaders });
    }

    getOrderPending() {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.get<DataOrder>(this.url + "/orderpending", { headers: iheaders });
    }

    saveStoreOrder(dataOrder: DataOrder) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<DataOrder>(this.url + "/savestoreorder", JSON.stringify(dataOrder), { headers: iheaders });
    }

    getAllOrders() {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.get<DataOrder>(this.url + "/consultAllorders", { headers: iheaders });
    }

    /**
     * Devuelve los pedidos en estado finalizado buscado por numero de ticket
     * @param storeTicketNumber 
     * @returns 
     */
    getFinishedOrdersPhysicalStore(storeTicketNumber: string) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.get<DataOrder>(this.url + "/finishedOrdersPhysicalStore/" + storeTicketNumber, { headers: iheaders });
    }

    /**
     * Confirma la devolución
     * @param order
     * @returns 
     */
    confirmReturn(dataOrder: DataOrder) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<DataOrder>(this.url + "/confirmReturn" ,JSON.stringify(dataOrder), { headers: iheaders });
    }

    /**
     * Guarda una nueva devolución
     * @param order
     * @returns 
     */
    saveReturn(order: DataOrder) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<DataOrder>(this.url + "/saveReturn" ,JSON.stringify(order), { headers: iheaders });
    }

    /**
     * Devuelve un pedido buscado por numero de pedido y estado finalizado
     * @param storeTicketNumber 
     * @returns 
     */
    getOrderByOrderNumberAndStatus(orderNumber: string) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<DataOrder>(this.url + "/orderByOrderNumberAndStatus", JSON.stringify(orderNumber), { headers: iheaders });
    }

    /**
     * Devuelve los pedidos unificados en estado finalizado buscado por numero de ticket
     * @param storeTicketNumber 
     * @returns 
     */
    getUnifyOrdersByStoreTicketNumber(storeTicketNumber: string) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.get<DataOrder>(this.url + "/unifyOrdersByStoreTicketNumber/" + storeTicketNumber, { headers: iheaders });
    }

    /**
     * Cancela una devolucion
     * @param storeTicketNumber 
     * @returns 
     */
    cancelReturn(dataOrder: DataOrder) {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<DataOrder>(this.url + "/cancelReturn" ,JSON.stringify(dataOrder), { headers: iheaders });
    }

}
